/* src/data/microExercisesData.js */

export const MICRO_EXERCISE_CATEGORIES = [
  {
    id: "grounding",
    emoji: "🧘‍♀️",
    title: "Grounding & Nervous System Reset",
    subtitle: "Quick exercises to calm, centre, and come back to the present moment.",
    subcategories: [
      { id: "sensory", label: "Sensory" },
      { id: "breathwork", label: "Breathwork" },
      { id: "somatic", label: "Somatic" },
      { id: "panic", label: "Panic Support" },
      { id: "slowdown", label: "Slow-down" },
      { id: "polyvagal", label: "Polyvagal" },
    ],
    exercises: [
      {
        id: "grounding-54321",
        componentId: "HelprrSensoryGrounding",
        title: "5-4-3-2-1 Grounding",
        subtitle: "Come back into your body using your senses.",
        duration: "30 sec",
        modality: "Sensory",
        subcategoryId: "sensory",
        image: "/assets/micro/img54321.png",
      },
      {
        id: "grounding-name-3",
        componentId: "HelprrNameThreeThings",
        title: "Name 3 Things",
        subtitle: "Gently orient to the room and feel safer.",
        duration: "30 sec",
        modality: "Sensory",
        subcategoryId: "sensory",
        image: "/assets/micro/img3.png",
      },
      {
        id: "grounding-box-breath",
        componentId: "HelprrBoxBreath",
        title: "Box Breath (4-4-4-4)",
        subtitle: "Slow your heart rate and steady your mind.",
        duration: "1 min",
        modality: "Breathwork",
        subcategoryId: "breathwork",
        image: "/assets/micro/imgboxbreath.png",
      },
      {
        id: "grounding-hand-on-chest",
        componentId: "HelprrBodyExercise",
        title: "Micro Body Release",
        subtitle: "Signal safety to your nervous system.",
        duration: "45 sec",
        modality: "Somatic",
        subcategoryId: "somatic",
        image: "/assets/illustrations/helprr-breathing.png",
      },
      {
        id: "grounding-panic-anchor",
        componentId: "HelprrPanicAnchor",
        title: "Panic Anchor",
        subtitle: "Anchor to one object when panic rises.",
        duration: "1 min",
        modality: "Panic",
        subcategoryId: "panic",
        image: "/assets/micro/imgpanicanchor.png",
      },
      {
        id: "grounding-vagus-hum",
        componentId: "HelprrVagusHum",
        title: "Soft Humming",
        subtitle: "Stimulate your vagus nerve gently.",
        duration: "1 min",
        modality: "Polyvagal",
        subcategoryId: "polyvagal",
        image: "/assets/micro/imghumming.png",
      },
      {
        id: "grounding-slow-down-list",
        componentId: "SlowDownList",
        title: "Slow Down List",
        subtitle: "Drop your speed by naming what can wait.",
        duration: "2 min",
        modality: "Slow-down",
        subcategoryId: "slowdown",
        image: "/assets/micro/imgslowdown.png",
      },
    ],
  },
];
